export enum LocalStorageStateKeys {
  PERMISSIONS_TABLE_SORT_COLUMN = "permissions_table_sort_column",
  MYJOBS_TABLE_SORT_COLUMN = "myjobs_table_sort_column",
}
